export default __webpack_public_path__ + "static/media/icon-messages.a93f061b.svg";